export default "__VITE_ASSET__Dz$ofkFy__"